var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notation-stars"},_vm._l((_vm.max),function(i){return _c('div',{key:i,staticClass:"star-container"},[_c('icon-star-empty',{staticClass:"star-empty"}),_vm._v(" "),_c('div',{staticClass:"star-fill-wrapper",style:({ width: _vm.getStarFillPercent(i) + '%' })},[_c('icon-star-full',{staticClass:"star-full"})],1)],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }